import '../node_modules/bootstrap';
import '../node_modules/bootstrap/js/dist/util';
import '../node_modules/bootstrap/js/dist/scrollspy';
import './scss/style.scss';
import './js/app.js';
import './js/nav.js';